import React, {useContext, useEffect} from "react";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import BackToEstimate from "../ClientInvoice/BackToEstimate";
import PrintInvoice1 from "../ClientInvoice/PrintInvoice1";
import PrintInvoice from "../CommonComponents/PrintInvoiceCommonButton";
import PayInvoiceForInvoice from "../CommonComponents/PayInvoiceForInvoice";

export default () => { //this component shows the back and print invoice buttons
    const BtnName = 'GO TO ESTIMATE'
    let PageView = useContext(ViewMangementContext)
    let Record = useContext(RecordsManagementContext)
    let ClientPortalData = Record.CP_PageDetails
    let ClientPortalHeader = ClientPortalData.ClientPortalHeader

    const printInvoice2 =  async () => { // Function to print Invoice2 in Pdf Format & DownLoad it.
        let Url =`${ClientPortalHeader.PrintPortal.url}/print_invoice_2?id=${ClientPortalHeader.PrintPortal.estimate_id}`
        window.open(Url)
    }
    const ShowTermsAndConditions = () => {//it will show terms and conditions of the company.
        PageView.Set('SHOW BACK PAGE')
    }
    const OpenEstimate = () => {//will render client portal on the screen.
        PageView.Set('CLIENT_PORTAL')
    }
    useEffect(() => {//it makes page header sticky
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });
    const isSticky = (e) => {//if scroll down the page ,even then header will always visible on the screen.
        const header = document.querySelector('.is-sticky');
        const scrollTop = window.scrollY;
        scrollTop  > 0 ? header.setAttribute('style', 'height: 50px; top: 0; border-bottom: #17a2b8 2px solid !important;')  :
            header.setAttribute('style', 'height: 50px; top: 0; border-bottom: 0px;');
    };
    const show_addendum = (e) => {//when we select addendum from the select box then it will show selected addendum on the screen
        Record.setSelectedAddendum(e.target.value)
        PageView.Set('SHOW ADDENDUM')
    }

    return(
        <table className="table">
            <tbody>
            <tr >
                <td className="td-main-bost">
                    <button  className='btn btn-dark btn-sm '
                             onClick={() => OpenEstimate()}>
                        <b>{BtnName}</b></button>
                </td>
                <td className="td-main-bost" style={{textAlign: "right",paddingLeft: '36px'}}>
                    {Record.IV2_PageDetails.AddendumPresent ?
                        <select className="custom-select" onChange={(e) =>show_addendum(e)}
                                style={{width:"20%",marginRight:"1%",height:"33px"}}>
                            <option defaultValue="Select Addendum">Select Addendum</option>
                            {Object.keys(Record.IV2_PageDetails.AddendumData).map((addendum_name,key) => {
                                return (
                                    <option key={key+"addendum_name_2"}
                                            value={Record.IV2_PageDetails.AddendumData[addendum_name].id}>
                                        {Record.IV2_PageDetails.AddendumData[addendum_name].name}</option>
                                )
                            })}
                        </select>
                        : <></> }
                    <PayInvoiceForInvoice />
                    <PrintInvoice />
                    <button className='btn btn-dark btn-sm ' onClick={() => ShowTermsAndConditions()}>
                        <b>SHOW BACK PAGE</b></button>
                </td>
            </tr>
            </tbody>
        </table>
    )
}